// extracted by mini-css-extract-plugin
export default {"rating":"ZP-z","numberOfStars":"_P-z","count":"aQ-z","barGraphSpacing":"bQ-z","barGraph":"cQ-z"};